import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CreateMutationRequest, CreateMutationResponse, Create400, Create401, Create403, Create404, Create410, Create422, Create429, Create500 } from "../types/Create";

/**
 * @link /api/credit-flow-backend/private/v1/funding
 */

export function useCreate <TData = CreateMutationResponse, TError = Create400 | Create401 | Create403 | Create404 | Create410 | Create422 | Create429 | Create500, TVariables = CreateMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/credit-flow-backend/private/v1/funding`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
